var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import configSectionActions from "../actions/ConfigSectionActions.js";
import { createReducer } from "@ane/legacy/lib/decorators/ReduxDecorators";
const initialState = {
  // TODO: Try having no sections (empty array)
  isError: false,
  sections: ["AnalysisConfig"],
  selectedSection: "AnalysisConfig"
};
class ConfigSectionReducer {
  getSections(state, action) {
    if (action.error === true || action.payload.length === 0) {
      return __spreadProps(__spreadValues({}, state), {
        isError: true
      });
    }
    const payload = action.payload;
    const sections = payload.filter((s) => s !== "ForayLayoutMappings");
    let selectedSection = state.selectedSection;
    if (sections.indexOf(selectedSection) === -1) {
      selectedSection = sections[0];
    }
    return __spreadProps(__spreadValues({}, state), {
      sections,
      selectedSection
    });
  }
  selectSection(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      selectedSection: action.payload
    });
  }
}
const reducer = createReducer(configSectionActions, new ConfigSectionReducer(), initialState);
export {
  ConfigSectionReducer,
  reducer as default
};
//# sourceMappingURL=ConfigSectionReducer.js.map
